import { render, staticRenderFns } from "./tableComponentResults.vue?vue&type=template&id=4c5caeeb&scoped=true"
import script from "./tableComponentResults.vue?vue&type=script&lang=js"
export * from "./tableComponentResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5caeeb",
  null
  
)

export default component.exports